import {Field, reduxForm} from 'redux-form'
import styles from './style.detail.css'

const smsInput = (props) => {
  const {input} = props
  return (<div>
    <input {...input} defaultValue='haesoo - ' placeholder='Reply SMS Feedback...' maxlength='160' type='text' className={`reply-text form-control ${styles['form-sms-feedback']}`} />
    <div className={styles['counter-feedback']}>{160 - input.value.length}</div>
  </div>
  )
}

const normalizeSMSForm = (value, prevVal, allValues) => {
  let result = ''
  if (value.length === 1) {
    result = allValues['business_name'] + value
  } else {
    result = allValues['business_name'] + value.substring(allValues['business_name'].length)
  }
  return result.slice(0, 160)
}
class FeedbackReplyForm extends React.Component {
  render () {
    let {handleSubmit, feedbackfrom} = this.props
    return (
      <form onSubmit={handleSubmit}>
        <Field
          component='input'
          data-fv-notempty='true'
          name='feedbackfrom'
          type='hidden'
        />
        <Field
          component='input'
          data-fv-notempty='true'
          name='business_name'
          type='hidden'
        />
        <div className='input-group'>
          {feedbackfrom === 'sms' && <Field
            component={smsInput}
            data-fv-notempty='true'
            name='comment'
            normalize={normalizeSMSForm}
          />}
          {feedbackfrom !== 'sms' && <Field
            component='input'
            className='reply-text form-control'
            data-fv-notempty='true'
            name='comment'
            placeholder='Reply Feedback...'
            type='text'
          />}
          <span className='input-group-btn'>
            <input
              className='btn btn-primary btn btn-primary'
              type='submit'
              value='Reply'
            />
          </span>
        </div>
      </form>
    )
  }
}

FeedbackReplyForm.propTypes = {
  onSubmit: React.PropTypes.func
}

export default reduxForm({
  form: 'feedbackReplyForm'
})(FeedbackReplyForm)



// WEBPACK FOOTER //
// ./app/pages/Customers/Feedback/FeedbackDetail/FeedbackReplyForm.js